const updateColors = store => async (state, primary, secondary) => {
    const isHex = /^#([a-f 0-9]{6})$/i;
    if (isHex.test(primary) && isHex.test(secondary)) {
        store.setState(
            {
                ...state,
                user: {
                    ...state.user,
                    overrides: {
                        ...state.user.overrides,
                        primaryColor: primary,
                        secondaryColor: secondary,
                    },
                },
            },
            true,
        );
    }
};

export default updateColors;
